'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _Panel = require('components/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _PopularityChart = require('components/Statistics/PopularityChart/PopularityChart');

var _PopularityChart2 = _interopRequireDefault(_PopularityChart);

var _statistics2 = require('selectors/statistics');

var _StatisticsCoverage = require('components/Statistics/StatisticsCoverage/StatisticsCoverage');

var _StatisticsCoverage2 = _interopRequireDefault(_StatisticsCoverage);

var _GeographyChartTypeWrapper = require('components/Statistics/GeographyChart/GeographyChartTypeWrapper');

var _GeographyChartTypeWrapper2 = _interopRequireDefault(_GeographyChartTypeWrapper);

var _DevicesChart = require('components/Statistics/DevicesChart/DevicesChart');

var _DevicesChart2 = _interopRequireDefault(_DevicesChart);

var _statistics3 = require('helpers/statistics');

var _PlayStatsChart = require('components/Statistics/PlayStatsChart/PlayStatsChart');

var _PlayStatsChart2 = _interopRequireDefault(_PlayStatsChart);

var _StatisticsTracksDetailsLink = require('components/Statistics/StatisticsTracksDetailsLink/StatisticsTracksDetailsLink');

var _StatisticsTracksDetailsLink2 = _interopRequireDefault(_StatisticsTracksDetailsLink);

var _StatisticsReminders = require('containers/Statistics/StatisticsReminders/StatisticsReminders');

var _StatisticsReminders2 = _interopRequireDefault(_StatisticsReminders);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectStatisticsOverall.scss');

var ProjectStatisticsOverall = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        projectId = _ref.params.projectId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadActivityStats({ projectId: projectId })).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    activityStatsLoading: state.statistics.activityStatsLoading,
    coverageData: (0, _statistics2.getCoverageData)(state),
    devicesData: (0, _statistics2.getDevicesData)(state),
    endDate: state.statistics.endDate,
    geographyCitiesData: (0, _statistics2.getGeographyCitiesData)(state),
    geographyCountriesData: (0, _statistics2.getGeographyCountriesData)(state),
    playStatsData: (0, _statistics2.getPlayStatsData)(state),
    popularityData: (0, _statistics2.getPopularityData)(state),
    projectId: Number(ownProps.params.projectId),
    startDate: state.statistics.startDate
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectStatisticsOverall, _Component);

  function ProjectStatisticsOverall() {
    (0, _classCallCheck3.default)(this, ProjectStatisticsOverall);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatisticsOverall.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatisticsOverall)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectStatisticsOverall, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var projectId = nextProps.projectId,
          startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
      if (isDateChanged && startDate && endDate) {
        this.props.loadActivityStats({ projectId: projectId, startDate: startDate, endDate: endDate });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          popularityData = _props.popularityData,
          coverageData = _props.coverageData,
          geographyCountriesData = _props.geographyCountriesData,
          geographyCitiesData = _props.geographyCitiesData,
          devicesData = _props.devicesData,
          projectId = _props.projectId,
          playStatsData = _props.playStatsData;
      var activityStatsLoading = this.props.activityStatsLoading;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.indent },
          _react2.default.createElement(
            _Panel2.default,
            { title: t('Recipients Statistics') },
            _react2.default.createElement(_PlayStatsChart2.default, { data: playStatsData, loading: activityStatsLoading })
          ),
          _react2.default.createElement(_StatisticsTracksDetailsLink2.default, { projectId: projectId })
        ),
        _react2.default.createElement(
          'h4',
          { className: 'h4 margin-vert-20' },
          t('Coverage')
        ),
        _react2.default.createElement(
          'div',
          { className: styles.indent },
          _react2.default.createElement(_StatisticsCoverage2.default, {
            data: coverageData,
            id: 'projectOverallCoverage',
            loading: activityStatsLoading,
            projectId: projectId
          }),
          !activityStatsLoading && _react2.default.createElement(_StatisticsReminders2.default, { projectId: projectId, className: styles.reminders })
        ),
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('File info') },
          _react2.default.createElement(_PopularityChart2.default, { data: popularityData, loading: activityStatsLoading })
        ),
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Geography of recipients') },
          _react2.default.createElement(_GeographyChartTypeWrapper2.default, {
            countriesPlaysData: geographyCountriesData.plays,
            countriesDownloadsData: geographyCountriesData.downloads,
            citiesPlaysData: geographyCitiesData.plays,
            citiesDownloadsData: geographyCitiesData.downloads,
            loading: activityStatsLoading
          })
        ),
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Device Types') },
          _react2.default.createElement(_DevicesChart2.default, {
            id: 'devicesStats',
            data: devicesData.devices,
            loading: activityStatsLoading
          })
        ),
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Source Types') },
          _react2.default.createElement(_DevicesChart2.default, {
            id: 'sourcesStats',
            reverseColors: true,
            data: devicesData.sources,
            loading: activityStatsLoading
          })
        )
      );
    }
  }]);
  return ProjectStatisticsOverall;
}(_react.Component), _class2.propTypes = {
  activityStatsLoading: _propTypes2.default.bool,
  coverageData: _propTypes2.default.object,
  devicesData: _propTypes2.default.object,
  endDate: _propTypes2.default.string,
  geographyCitiesData: _propTypes2.default.object,
  geographyCountriesData: _propTypes2.default.object,
  loadActivityStats: _propTypes2.default.func,
  playStatsData: _propTypes2.default.array,
  popularityData: _propTypes2.default.array,
  projectId: _propTypes2.default.number,
  startDate: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  coverageData: {},
  devicesData: _statistics3.defaultDevicesData,
  geographyCitiesData: _statistics3.defaultGeographyData,
  geographyCountriesData: _statistics3.defaultGeographyData,
  playStatsData: [],
  popularityData: [],
  projectInfo: {}
}, _temp)) || _class) || _class);
exports.default = ProjectStatisticsOverall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/ProjectStatisticsOverall/ProjectStatisticsOverall.js
// module id = 2215
// module chunks = 1